import FacetFilter from "./components/FacetFilter/index.js";
export default FacetFilter;